import React, { useState, useEffect } from 'react';
import { getDate, getMatchURL } from '../utils';
import { TeamLogo } from './teamLogo';


/**
 * Player Game Log Table
 */
const GameLogBox = (props) => {
    const { 
        data = null,
        ...restProps 
    } = props;

    // Return nothing if we don't have any data yet
    if ( !data ) return;

    let state;
    switch (data.liveStatus) {
        case 'PLAYED':
            state = 'played';
            break;
        case 'SCHEDULED':
        case 'POSTPONED':
        case 'CANCELED':
            state = 'scheduled';
            break;
        case 'PLANNED':
            state = 'scheduled';
            break;
        default:
            state = 'running';
            break;
    }

    // Get the winner
    let winner;
    if ( state == 'played' ) {
        // Check for penalty wins first
        if ( data.awayTeamResult.hasOwnProperty('penaltyWin') && data.awayTeamResult.penaltyWin ) {
            winner = 'away';
        } else if ( data.homeTeamResult.hasOwnProperty('penaltyWin') && data.homeTeamResult.penaltyWin ) {
            winner = 'home';
        } else if ( data.awayTeamResult.hasOwnProperty('current') && data.homeTeamResult.hasOwnProperty('current') ) {
            // Check for wins without penalties
            if ( data.awayTeamResult.current > data.homeTeamResult.current ) {
                winner = 'away';
            } else if ( data.awayTeamResult.current < data.homeTeamResult.current ) {
                winner = 'home';
            } else {
                winner = 'tie';
            }
        }
    }
    
    // Get grouped stats
    let groupedStats = [];
    if ( data.playerMatchStats.hasOwnProperty('singleYellow') && data.playerMatchStats.singleYellow ) {
        groupedStats.push('singleYellow');
    }
    if ( data.playerMatchStats.hasOwnProperty('secondYellow') && data.playerMatchStats.secondYellow ) {
        groupedStats.push('secondYellow');
    }
    if ( data.playerMatchStats.hasOwnProperty('red') && data.playerMatchStats.red ) {
        groupedStats.push('red');
    }

    // Set up class list
    let classes = 'smallMatch';
    classes += ' smallMatch--' + state;
    classes += ' smallMatch--gameLog';


    // Return the table of game logs
    return (
        <a href={getMatchURL(data.id)} className={classes}>

            <div className="smallMatch__meta">
                { data.hasOwnProperty('dateTimeUTC') ? (
                    <div className="smallMatch__date">{ getDate(data.dateTimeUTC, 'monthDay') }</div>
                ) : '' }
            </div>

            <div className="smallMatch__teams">
                { data.hasOwnProperty('homeTeam') && data.homeTeam ? (
                    <div className="smallMatch__team smallMatch__team--home" data-winner={winner == 'home' || winner == 'tie' ? 'true' : 'false' } data-player={data.team == 'H' ? 'true' : 'false'}>
                        { data.homeTeam && data.homeTeam.hasOwnProperty('picture') ? (
                            <TeamLogo defaultPictureId={data.homeTeam.picture} />
                        ) : '' }
                        <div className="smallMatch__teamName">{data.homeTeam.name}</div>
                        <div className="smallMatch__teamScore">{ data.homeTeamResult ? data.homeTeamResult.current : '' }</div>
                    </div>
                ) : '' }
                { data.hasOwnProperty('awayTeam') && data.awayTeam ? (
                    <div className="smallMatch__team smallMatch__team--away" data-winner={winner == 'away' || winner == 'tie' ? 'true' : 'false' } data-player={data.team == 'A' ? 'true' : 'false'}>
                        { data.awayTeam && data.awayTeam.hasOwnProperty('picture') ? (
                            <TeamLogo defaultPictureId={data.awayTeam.picture} />
                        ) : '' }
                        <div className="smallMatch__teamName">{data.awayTeam.name}</div>
                        <div className="smallMatch__teamScore">{ data.awayTeamResult ? data.awayTeamResult.current : '' }</div>
                    </div>
                ) : '' }
            </div>

            { data.hasOwnProperty('playerMatchStats') ? (
                <div className="smallMatch__stats">
                    { data.playerMatchStats.hasOwnProperty('minutesPlayed') && data.playerMatchStats.minutesPlayed ? (
                        <GameLogBoxStat type="minutesPlayed" stat={data.playerMatchStats.minutesPlayed + "'"} />
                    ) : (
                        <GameLogBoxStat type="minutesPlayed" stat={"0'"} />
                    ) }
                    { data.playerMatchStats.hasOwnProperty('goals') && data.playerMatchStats.goals ? (
                        <GameLogBoxStat type="goals" stat={data.playerMatchStats.goals} />
                    ) : '' }
                    <GameLogBoxGroupedStat include={groupedStats} />
                </div>
            ) : '' }

            
        </a>
    );
}


const GameLogBoxStat = (props) => {
    const { 
        type = null,
        stat = null,
        ...restProps 
    } = props;
    if ( !type || stat == null ) return;

    return (
        <div className="smallMatch__stat">
            <span className={"smallMatch__statIcon smallMatch__statIcon--" + type}></span>
            <span className="smallMatch__statNumber">{stat}</span>
        </div>
    );

}
const GameLogBoxGroupedStat = (props) => {
    const { 
        include = null,
        ...restProps 
    } = props;
    if ( !include ) return;

    return (
        <div className="smallMatch__stat smallMatch__stat--grouped">
            { include.map((item, i) => (
                <span key={i} className={"smallMatch__statIcon smallMatch__statIcon--" + item}></span>
            )) }
        </div>
    );

}





export { GameLogBox };